import { render, staticRenderFns } from "./SandboxCitations.vue?vue&type=template&id=8cb91164&"
import script from "./SandboxCitations.vue?vue&type=script&setup=true&lang=js&"
export * from "./SandboxCitations.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8cb91164')) {
      api.createRecord('8cb91164', component.options)
    } else {
      api.reload('8cb91164', component.options)
    }
    module.hot.accept("./SandboxCitations.vue?vue&type=template&id=8cb91164&", function () {
      api.rerender('8cb91164', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/onboardingShell/steps/sandbox/SandboxCitations.vue"
export default component.exports